const styles = () => ({
	container: {
		padding: '2em 4em'
	},
	title: {},
	'@media (min-width: 640px)': {
		title: {}
	},
	'@media (max-width: 640px)': {
		container: {
			paddingLeft: '0.5em',
			paddingRight: '0.5em'
		}
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/pages/terms/styles.js